import { DisputesConnection, DisputesEdge } from '@varo/graphql-schema-types';
import React, { useEffect, useRef } from 'react';
import { FlatList, StyleSheet, View } from 'react-native';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import ErrorScreen, {
  ErrorScreenProps,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';
import theme from 'shared/styles/theme';

import DisputesItem from './DisputesItem';
import NoDisputesScreen from './NoDisputesScreen';

interface DashboardScreenProps {
  disputesListDetails: DisputesConnection | undefined;
  errorModel: ErrorScreenProps | null;
  loading: boolean;
  selectedTab: string;
}
const DashboardScreen = ({
  disputesListDetails,
  errorModel,
  loading,
  selectedTab,
}: DashboardScreenProps) => {
  const flatListRef = useRef<FlatList>(null);

  useEffect(() => {
    if (flatListRef.current) {
      flatListRef.current.scrollToOffset({ offset: 0, animated: true });
    }
  }, [selectedTab]);

  return (
    <View style={styles.container}>
      <ScreenTransitionOverlay
        isLoading={loading}
        LoadingComponent={<LoadingSpinner />}
        ErrorComponent={errorModel ? <ErrorScreen {...errorModel} /> : null}
      />

      {disputesListDetails?.edges?.length ? (
        <FlatList
          ref={flatListRef}
          data={disputesListDetails.edges}
          renderItem={({ item }: { item: DisputesEdge }) => (
            <DisputesItem item={item} />
          )}
          ItemSeparatorComponent={() => <View style={styles.hairLineDivider} />}
          keyExtractor={(item: { node: { id: string } }) => item.node.id}
          removeClippedSubviews={false}
          testID="disuteItem"
        />
      ) : (
        <NoDisputesScreen selectedTab={selectedTab} />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flexGrow: 1,
    flex: 1,
  },
  hairLineDivider: {
    backgroundColor: theme.color.border.primary,
    height: 8,
  },
});

export default DashboardScreen;
